import { SkeletonCard } from '../components/ui/Skeleton'
import { KILO } from '../constants/KILO_THEME'

const Loading = () => (
  <div className={`flex min-h-screen flex-col ${KILO.bg.page}`} aria-busy="true" aria-label="Loading">
    {/* Sticky header placeholder */}
    <div className="sticky top-0 z-20 border-b border-kilo-border bg-kilo-page/95 px-4 py-3 backdrop-blur">
      <div className="kilo-skeleton h-2.5 w-20 rounded-full" aria-hidden="true" />
      <div className="kilo-skeleton mt-2 h-6 w-36 rounded-lg" aria-hidden="true" />
    </div>

    {/* Content skeleton — three cards mimicking the Coach tab layout */}
    <div className="flex flex-col gap-3 px-4 pb-28 pt-4">
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>

    {/* Bottom tab bar placeholder */}
    <div className="fixed bottom-0 left-0 right-0 flex h-16 items-center justify-around border-t border-kilo-border bg-kilo-card/95 px-4 backdrop-blur">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="flex flex-col items-center gap-1.5" aria-hidden="true">
          <div className="kilo-skeleton h-6 w-6 rounded-lg" />
          <div className="kilo-skeleton h-2 w-8 rounded-full" />
        </div>
      ))}
    </div>
  </div>
)

export default Loading
